// app/javascript/components/Navbar.js
import { useNavigate } from "react-router-dom";
import { Box, Link } from "@mui/material";
import { useState, useRef } from "react";
import { useEffect } from "react";
import "../../stylesheets/index.css";
import { isDarkMode, themeColors } from "../utils/constants";
import { ShareModal } from "../utils/share";
import "../../stylesheets/navbar.css";
import { getWatchlistData } from "../api/user";
import { isMobileBrowser } from "../utils/user_agent";
import { checkUserHasAccount } from "../utils/user";
import { CHAT_DRAWER_WIDTH } from "./Chat/Sidebar";
import { checkUserHasSubscription } from "../utils/user";

const DATA_PROCESSES_WIDTH = 280;

const Navbar = (props) => {
  const {
    allowAbout,
    appProps,
    useLightMode,
    headerDescription,
    isSidebarOpen,
    isDataProcessesOpen,
  } = props;
  const {
    setWatchlistData,
    setShowSignUpModal,
    showWatchlistBlueDot,
    setShowWatchlistBlueDot,
    showWatchlistFlicker,
  } = appProps;

  const navigate = useNavigate();
  const isMobile = isMobileBrowser();
  const { userData, setUserData } = appProps;

  const useIsDarkMode = !useLightMode == true && isDarkMode;
  const hasSubscription = checkUserHasSubscription(userData);
  const isMaxSubscriber =
    hasSubscription && userData.subscription_plan_tier === "max";

  let isLoggedIn = !!appProps.userData.user_id;

  let classNavbarText = useIsDarkMode
    ? "navbar-text-styles dark"
    : "navbar-text-styles";
  const [modalVisible, setModalVisible] = useState(false);
  const [showSignInButton, setShowSignInButton] = useState(false);
  const [watchlistVisible, setWatchlistVisible] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setWatchlistVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [watchlistVisible]);

  useEffect(() => {
    if (isLoggedIn) {
      getWatchlistData(setWatchlistData);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (checkUserHasAccount(userData)) {
      setShowSignInButton(false);
    } else {
      setShowSignInButton(true);
    }
  }, [userData]);

  return (
    <Box
      className="navbar-container"
      sx={{ opacity: 0.98, backgroundColor: themeColors.navColor }}
    >
      <Box className="navbar-hamburger-container">
        <Box className="navbar-hamburger">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "0px",
            }}
          >
            {window.location.pathname == "/chat" && (
              <Box
                sx={{
                  "&:hover": { cursor: "pointer" },
                  color: themeColors.linkColor,
                  fontSize: "16px",
                }}
                onClick={() => {
                  if (isLoggedIn) {
                    setShowWatchlistBlueDot(false);
                    setWatchlistVisible(!watchlistVisible);
                  } else {
                    setShowSignUpModal(true);
                  }
                }}
              >
                {showWatchlistBlueDot && (
                  <Box
                    className={
                      showWatchlistFlicker ? "fade-animation" : "unset"
                    }
                    sx={{
                      backgroundColor: "rgba(78, 120, 241, 1.0)",
                      position: "absolute",
                      left: "35px",
                      top: "17px",
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </Box>
            )}

            {allowAbout && isLoggedIn && (
              <Box
                className={classNavbarText}
                sx={{
                  marginLeft: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ShareModal
                  modalVisible={modalVisible}
                  setModalVisible={setModalVisible}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...(isMobile
            ? { transform: "unset", transition: "unset", willChange: "unset" }
            : {
                // +half left, -half right
                transform: `translateX(${
                  (isSidebarOpen ? CHAT_DRAWER_WIDTH / 2 : 0) -
                  (isDataProcessesOpen ? DATA_PROCESSES_WIDTH / 2 : 0)
                }px)`,
                transition: "transform 300ms ease-in-out",
                willChange: "transform",
              }),
        }}
      >
        {headerDescription ? (
          <h1
            className="base-text main-header-text"
            style={{ color: themeColors.color }}
          >
            {headerDescription}
          </h1>
        ) : hasSubscription ? (
          <Box
            sx={{
              ...(isMaxSubscriber && {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }),
            }}
          >
            <Box
              className="base-text"
              sx={{
                fontSize: isMobile ? "15px" : "18px",
                marginTop: "-4px",
                fontWeight: 600,
                letterSpacing: "0.08em",
                // textTransform: "uppercase",
                px: isMobile ? 1.8 : 2.6,
                py: isMobile ? 0.4 : 1,
                borderRadius: "999px",
                // Sleeker, darker badge for MAX branding.
                background: isDarkMode
                    ? "#232A3D"
                    : " #3974CC",
                boxShadow: isMaxSubscriber
                  ? "inset 0 1px 0 rgba(255,255,255,0.16), 0 2px 8px rgba(3, 7, 18, 0.2)"
                  : "0 0 8px rgba(217, 226, 248, 0.25)",
                border: "1px solid rgba(114, 156, 224, 0.65)",
                color: isMaxSubscriber
                  ? "#FFFFFF"
                  : isDarkMode
                    ? "#F5F3FF"
                    : "#FFFFFF",
                backdropFilter: isMaxSubscriber ? "none" : "blur(4px)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
                ...(isMaxSubscriber && {
                  position: "relative",
                }),
              }}
            >

              {isMaxSubscriber ? (
                'Incite MAX'
              ) : (
                "Incite Pro"
              )}
            </Box>
          </Box>
        ) : (
          <Box
            className="base-text"
            sx={{
              fontSize: isMobile ? "16px" : "24px",
              marginTop: "-5px",
              fontWeight: 500,
              color: isDarkMode ? "white" : "black",
            }}
          >
            Incite
          </Box>
        )}
      </Box>

      <Box
        className="navbar-hamburger-container"
        sx={{
          width: showSignInButton ? "50px" : "50px", // not showing sign in button, need same padding.
          marginRight: showSignInButton && isMobile ? "32" : "32px",
        }}
      >
        <Box className="navbar-hamburger">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "0px",
            }}
          >
            {headerDescription == "Sign up" ? (
              <Box
                sx={{ width: "80px", fontSize: "11px", marginRight: "30px" }}
                className="base-text sign-text"
              >
                <Link
                  sx={{
                    "&:hover": { cursor: "pointer" },
                    color: themeColors.linkColor,
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    setUserData({ ...userData, uuidHasAccount: true });
                    navigate("/register");
                  }}
                >
                  Sign In
                </Link>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        </Box>
      </Box>
      <AccountButton appProps={props.appProps} />
    </Box>
  );
};

const AccountButton = (props) => {
  const { appProps } = props;
  return (
    <div className="navbar-account-container">
      <p
        className="navbar-text-styles"
        onClick={() => {
          appProps.setAccountModalOpen(true);
        }}
      >
        Account
      </p>
    </div>
  );
};

export { Navbar };
